import { Refill } from '@/types/transactions/refill'

export const refill1: Refill = {
    id: 1,
    date_time: '2025-08-18',
    total: 10,
    current_credit: 15,
}

export const refill2: Refill = {
    id: 2,
    date_time: '2025-08-17',
    total: 5,
    current_credit: 25,
}

export const refill3: Refill = {
    id: 3,
    date_time: '2025-08-16',
    total: 15,
    current_credit: 15,
}
